import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Clock, ArrowRight, Sparkles } from "lucide-react";
import { Link } from "wouter";

interface ExpiredPageProps {
  notFound?: boolean;
}

export function ExpiredPage({ notFound = false }: ExpiredPageProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-100 dark:from-purple-950 dark:via-blue-950 dark:to-indigo-950 flex items-center justify-center p-4">
      <Card className="max-w-lg w-full text-center" data-testid="expired-page">
        <CardContent className="py-12 px-6 space-y-6">
          <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mx-auto">
            <Clock className="w-8 h-8 text-muted-foreground" />
          </div>

          <div className="space-y-3">
            <h1 className="text-2xl lg:text-3xl font-bold font-playfair">
              {notFound
                ? "Seite nicht gefunden"
                : "Diese Vorschau ist leider nicht mehr verfügbar"}
            </h1>
            <p className="text-muted-foreground">
              {notFound
                ? "Die angeforderte Seite existiert nicht oder wurde entfernt."
                : "Der Link zu dieser personalisierten Vorschau ist abgelaufen."}
            </p>
          </div>

          <div className="pt-4 space-y-4">
            <p className="text-sm text-muted-foreground flex items-center justify-center gap-2">
              <Sparkles className="w-4 h-4 text-primary" />
              Interessiert am Social Media A-Team?
            </p>

            <Button asChild size="lg" data-testid="button-back-to-landing">
              <Link href="/vsl">
                Mehr erfahren
                <ArrowRight className="w-4 h-4 ml-2" />
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
